module.exports = __webpack_public_path__ + "static/media/VU6210F0.9754fa7c.png";